import { useThemeObserver } from '@atlaskit/tokens';

export function useIsDarkMode() {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark';
}
